import { Component } from 'react';
import { isRecordingRunning } from '../functions';
/**
 * Abstract class for the {@code ParticipantsRecordingLabel} component.
 */
export default class AbstractParticipantsRecordingLabel extends Component {
    /**
     * Implements React {@code Component}'s render.
     *
     * @inheritdoc
     */
    render() {
        const { _isVisible } = this.props;
        return _isVisible ? this._renderLabel() : null;
    }
    /**
     * Renders the platform specific label component.
     *
     * @protected
     * @returns {React$Element}
     */
    _renderLabel() {
        return null;
    }
}
/**
 * Maps (parts of) the Redux state to the associated
 * {@code AbstractParticipantsRecordingLabel}'s props.
 *
 * @param {Object} state - The Redux state.
 * @param {IProps} ownProps - The component's own props.
 * @private
 * @returns {{
 *     _isVisible: boolean
 * }}
 */
export function _mapStateToProps(state, ownProps) {
    const userRecordingCount = state['features/recording'].userRecordingCount;
    const isLocalRecording = isRecordingRunning(state);
    const _isVisible = userRecordingCount > 0 && !isLocalRecording;
    return {
        _isVisible,
    };
}
